import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionSheetController, AlertController, LoadingController, MenuController, ModalController, NavParams, PopoverController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
// import { ComFilterLeadsComponent } from '../com-filter-leads/com-filter-leads.component';
// import { UtilService } from '../services/util/util.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pp-assign-detail',
  templateUrl: './pp-assign-detail.component.html',
  styleUrls: ['./pp-assign-detail.component.css']
})
export class PpAssignDetailComponent implements OnInit {
  
    load: boolean = false;
    button: boolean = false;
    token: any;
    user: any;
    hasil: any;
    hsl: any;
    kw: any;
  
    selct: any = '';
    keterangan: any = '';
    members: { [key: string]: { name: string; position: string }[] } = {};
    
    constructor(
      public popoverController: PopoverController,
      public modalController: ModalController,
      public menuCtrl: MenuController,
      public route: Router,
      public http: HttpClient,
      public loadingctrl: LoadingController,
      public alertctrl: AlertController,
      public util: UtilService,
      public activatedRoute: ActivatedRoute,
      public actionSheetController: ActionSheetController,
      public navParams: NavParams,
      public api: ApiService
    ) {
  
      this.kw = this.navParams.data.id;
      console.log('KW', this.kw);
    }
  
    ngOnInit() {
     this.getList();
    }

    getList() {
      this.load = true;
      this.api.get('backoffice/pp/assign/list/'+this.kw)
        .subscribe((data) => {
          this.hasil = data;
          this.hsl = this.hasil.data;
          this.load = false;
          this.members = this.hsl.members as { [key: string]: any[] };         
        }, (error) => {
          this.load = false;
          console.log('error', error);
          this.api.errorCond(error);
        });
    }
  
    batal(){
      this.modalController.dismiss();
    }

  
    pilih(p){
      console.log(p);
      if(this.selct == ''){
        this.selct = p;
      } else if (this.selct == p){
        this.selct = '';
      } else {
        this.selct = p;
      }
      console.log('selct', this.selct);
    }
  
  }
  